import React from "react";
import WorkflowsDashboard from "../dashboard/dashboard";
import WorkflowsList from "../list/list";

const WorkflowsLanding = () => {
  return (
    <div>
      <div className="mt-4">
        <WorkflowsList />
      </div>
    </div>
  );
};

export default WorkflowsLanding;
